import ResizeObserver from 'resize-observer-polyfill';
import { ref, onMounted, onBeforeUnmount } from 'vue';

// We Expect a Map of <Width in PX>: 'className'
// eg {375:'xs', 420: 'sm', 760: 'md', 1440: 'lg', bigger: 'xl'}
const useBreakpoints = (breakpoints: { [key: number]: string; bigger?: string }) => {
  const watchedEl = ref<HTMLElement>();
  const currentBreakPoint = ref('');
  let observer: ResizeObserver;

  const onWidthChange = (newWidth) => {
    // Find the current breakpoint
    const key =
      Object.keys(breakpoints)
        .sort((a, b) => +a - +b)
        .find((breakPoint) => +breakPoint > +newWidth) || 'bigger';

    if (key) {
      currentBreakPoint.value = breakpoints[key] || '';
    }
  };

  onMounted(() => {
    if (!watchedEl.value) {
      return;
    }

    observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const { width } = entry.contentRect;

        onWidthChange(width);
      });
    });
    observer.observe(watchedEl.value);
  });

  onBeforeUnmount(() => {
    if (observer) {
      observer.disconnect();
    }
  });

  return {
    currentBreakPoint,
    watchedEl,
  };
};

export default useBreakpoints;
